import {
  ImageBackground,
  StyleSheet,
  useWindowDimensions,
  SafeAreaView,
  Image,
} from "react-native";
import React, { useState } from "react";
import { StackScreenProps } from "../../types";
import {
  View,
  Text,
  Heading,
  Pressable,
  ScrollView,
  Box,
  HStack,
  Flex,
} from "native-base";
import Header from "../../components/Header";

const slideItems = [
  {
    text: "Detailed soil survey and soil fertility mapping to enhance management of problematic soils. ",
    image: require("../../assets/vectors/survey.png"),
  },
  {
    text: "Dissemination of innovation and technologies for managing problematic soils in Nigeria.",
    image: require("../../assets/vectors/box.png"),
  },
  {
    text: "Evaluation of small-scale demonstration plots for promoting participatory evaluation of technologies and training of farmers on farmers’ fields.",
    image: require("../../assets/vectors/chart.png"),
  },
  {
    text: "Technology diffusion and sensitization of demonstration plots results for improved crop production and livelihood.",
    image: require("../../assets/vectors/plant.png"),
  },
  {
    text: "Sensitization of the private sector, financial institutions, and policymakers on the management of problematic soils.",
    image: require("../../assets/vectors/finance.png"),
  },
];

type RenderItemProps = { item: { text: string; image: any }[]; index: number };

const renderItem = ({ item, index }: RenderItemProps) => (
  <>
    {item?.map((itm) => (
      <Box
        bg="white"
        p={3}
        justifyContent="center"
        mb={5}
        borderWidth={4}
        borderColor="#ddd"
        borderRadius={15}
        key={itm.text}
      >
        <Image
          source={itm?.image}
          style={{
            width: 24,
            height: 28,
            alignSelf: "center",
            marginBottom: 10,
          }}
        />
        <Text color={"#009C4D"} textAlign="center">
          {itm?.text}
        </Text>
      </Box>
    ))}
  </>
);

const SoilResearch = ({ navigation }: StackScreenProps<"CropResearch">) => {
  const { width, height } = useWindowDimensions();
  const [activeSlide, setActiveSlide] = useState(1);

  return (
    <View style={styles.container}>
      <ImageBackground
        source={require("../../assets/soil-research-bg.png")}
        resizeMode="cover"
        style={{ width, height }}
      >
        <View style={styles.overlay}>
          <SafeAreaView style={{ height }}>
            <ScrollView
              px="6"
              contentContainerStyle={{
                flex: 1,
                paddingBottom: 20,
              }}
            >
              <Header
                onPress={() => navigation.navigate("ResearchAndDev")}
                parentText=" Research & Development"
                headingText="Soil Research"
              />

              <Text textAlign="center" mt={5}>
                In collaboration with the Nigerian Institute of Soil Science
                (NISS), OCP has been involved in soil research projects to
                develop sustainable and innovative solutions to address key
                barriers to the full realization of the agricultural growth
                potential in Nigeria. One of those areas of soil research in
                which OCP has been actively involved is the Problematic Soils
                Project.
              </Text>

              <Box
                width={"2/3"}
                // h="16"
                my={5}
                margin="auto"
                borderBottomColor="#000"
                borderColor={"#555"}
                borderWidth="1"
                borderRadius={15}
                p={1}
              >
                <Pressable onPress={() => navigation.navigate("NutrientMaps")}>
                  <Text textAlign="center">Tap to View nutrient map</Text>
                </Pressable>
              </Box>

              <Text textAlign="center" mb={10}>
                In achieving the objectives of its collaboration with the NISS,
                OCP has supported the following:
              </Text>

              <Flex direction="row" flexWrap={"wrap"} justifyContent="center">
                {slideItems.map((item, i) => (
                  <Box
                    bg="white"
                    p={3}
                    justifyContent="center"
                    mb={5}
                    mr={2}
                    borderColor="#ddd"
                    borderRadius={15}
                    key={item.text}
                    w={"2/3"}
                    h={"40"}
                  >
                    <Image
                      source={item?.image}
                      style={{
                        width: 24,
                        height: 28,
                        alignSelf: "center",
                        marginBottom: 10,
                      }}
                    />
                    <Text color={"#009C4D"} textAlign="center">
                      {item?.text}
                    </Text>
                  </Box>
                ))}
              </Flex>

              <View mt={10}></View>
            </ScrollView>
          </SafeAreaView>
        </View>
      </ImageBackground>
    </View>
  );
};

export default SoilResearch;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  imageContainer: {
    flex: 1,
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(106,63,36,0.8)",
  },
  slideContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  slide1: {
    backgroundColor: "rgba(20,20,200,0.3)",
  },
  slide2: {
    backgroundColor: "rgba(20,200,20,0.3)",
  },
  slide3: {
    backgroundColor: "rgba(200,20,20,0.3)",
  },
});
